import React, { createContext } from "react";
import { UseFormReturn } from "react-hook-form";

export const WfFormRendererContext = createContext<
  { form?: UseFormReturn } | undefined
>(undefined);

export function WfFormRendererContextProvider({
  form,
  children,
}: Readonly<{ form: UseFormReturn; children: React.ReactNode }>) {
  return (
    <WfFormRendererContext.Provider value={{ form }}>
      {children}
    </WfFormRendererContext.Provider>
  );
}
